import { ReflectiveInjector, Type, InjectionToken, Provider, AbstractType } from '../classes/injector';
import { useContext, useMemo } from 'react';
import { AngularDIContext } from '../components/angular-di/di-context';

export default function useService<T>(service: Type<T> | InjectionToken<T> | AbstractType<T>, notFoundValue?: T): T {
  const angularDIRef = useContext(AngularDIContext);
  return angularDIRef?.get(service, notFoundValue);
}

export function useRegisterProviders(providers: Provider[]) {
  const angularDIRef = useContext(AngularDIContext);

  return useMemo(() => {
    try {
      return ReflectiveInjector.resolveAndCreate(providers, angularDIRef);
    } catch (e) {
      console.log(e);
      return undefined;
    }
  }, [ angularDIRef ]);
}
